import script from "./BasisTargets.vue?vue&type=script&setup=true&lang=js"
export * from "./BasisTargets.vue?vue&type=script&setup=true&lang=js"

import "./BasisTargets.vue?vue&type=style&index=0&id=d73836ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d73836ce"]])

export default __exports__